// extracted by mini-css-extract-plugin
module.exports = {"confirmationWrapper":"s","header":"t","title":"u","subHeader":"v","buttonsWrapper":"w","confirmButton":"x","large":"y","cancelButton":"z"};